<div class="kal-autocomplete-virtual-scroll-viewport"
     [style.width]="width"
     [ngClass]="getClasses()">

  <div *ngIf="loading; else displayOptionsTemplate"
       [style.height]="height"
       [kalLoading]="loading">
  </div>

  <ng-template #displayOptionsTemplate>

    <!-- Message si liste vide (hauteur auto : le panneau se rétracte) -->
    <div *ngIf="emptyLabel && (!options || options.length === 0); else optionsListTemplate"
         class="kal-autocomplete-empty">
      {{ emptyLabel }}
    </div>

    <ng-template #optionsListTemplate>

    <cdk-virtual-scroll-viewport
      [id]="id"
      [itemSize]="virtualScrollConfig.itemSize"
      [style.height]="height">

    <ng-container *cdkVirtualFor="let option of options; index as i">

        <kal-option (click)="select(option)"
                    (selectionChange)="select(option)"
                    [disabled]="option.disabled"
                    [label]="option.label"
                    [value]="option">

          <ng-container
            *ngTemplateOutlet="data.optionTemplate ? data.optionTemplate : noTemplate; context: {index: i, option: option}"></ng-container>

          <ng-template #noTemplate>{{ option.label }}</ng-template>

        </kal-option>

      </ng-container>

    </cdk-virtual-scroll-viewport>

    </ng-template>

  </ng-template>

</div>
